import { makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import colors from '../../../../themes/main-colors';
import { CustomButtons } from '../common/footer-buttons/ButtonsComp';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: '0 1.5rem',
    background: colors.white,
    padding: '1rem',
    [theme.breakpoints.down('sm')]: {
      margin: '1.5rem 1.5rem 0 1.5rem',
    },
  },
  icon: {
    display: 'grid',
    justifyContent: 'center',
  },
  cardHeaderStyles: {
    fontSize: 24,
    fontWeight: 600,
    margin: 0,
    marginTop: 15,
  },
  contentStyles: {
    fontSize: 18,
    margin: '0rem 1rem',
  },
  bottonOneContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '2rem',
  },
  buttonOne: {
    fontSize: 18,
    color: colors.sparkBlue,
    fontWeight: 600,
    '&:hover': {
      background: 'transparent',
    },
  },
  buttonTwoContainer: {
    display: 'flex',
    gap: '15px',
    padding: '1rem 2rem',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
    },
  },
  buttonTwoContainerFirstButton: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  savePreferencesButton: {
    borderRadius: '20px',
    background: colors.orange,
    color: colors.white,
    fontSize: 18,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: colors.orange,
      borderColor: colors.orange,
    },
  },
}));

type cardData = {
  icon?: React.ReactNode;
  cardHeader?: React.ReactNode;
  content?: React.ReactNode;
  buttonOne?: string;
  buttonTwo?: React.ReactNode | string;
  buttonOneOnClick?: () => void;
  buttonTwoOnClick?: () => void;
};

export function OutageAcknowledgementCard(props: cardData) {
  const classes = useStyles();

  const {
    icon,
    cardHeader,
    content,
    buttonOne,
    buttonTwo,
    buttonOneOnClick,
    buttonTwoOnClick,
  } = props;

  return (
    <>
      <div className={classes.root}>
        <div>
          <div className={classes.icon}>
            <div className={classes.icon}>{icon}</div>
            <p className={classes.cardHeaderStyles}>{cardHeader}</p>
          </div>
          <p className={classes.contentStyles}>{content}</p>
        </div>
      </div>
      <CustomButtons
        buttonOne={buttonOne}
        buttonTwo={buttonTwo}
        buttonOneOnClick={buttonOneOnClick}
        buttonTwoOnClick={buttonTwoOnClick}
      />
    </>
  );
}
